import vendorTypes from './vendor.types'
import { takeLatest, put, all, call } from 'redux-saga/effects';
import { auth } from './../../firebase/utils';
import { handleAddService, handleFetchServices, handleDeleteService, handleFetchService,handleFetchVendors } from './vendor.helpers';
import { setServices, setService, fetchServicesStart } from './vendor.actions';

export function* addService({ payload }) {

	try {
	  const timestamp = new Date();
	  const  id  = auth.currentUser.uid
	  yield handleAddService(id,{
		...payload,
		createdDate: timestamp,
	  });
	  yield put(
		fetchServicesStart()
	  );
  
  
	} catch (err) {
	  console.log(err);
	}
  
}

export function* onAddServiceStart() {
	yield takeLatest(vendorTypes.ADD_NEW_SERVICE_START, addService);
}

export function* fetchServices({ payload }) {
	try {
		const  id  = auth.currentUser.uid
	  const services = yield handleFetchServices(id, payload);
	  yield put(
		setServices(services)
	  );
  
	} catch (err) {
	  console.log(err);
	}
}

export function* onFetchServicesStart() {
	yield takeLatest(vendorTypes.FETCH_SERVICES_START, fetchServices);
}

export function* deleteService({ payload }) {
	try {
		const  id  = auth.currentUser.uid
	  yield handleDeleteService(id, payload);
	  yield put (
		fetchServicesStart()
	  );
  
	} catch (err) {
	  // console.log(err);
	}
  }
  
export function* onDeleteServiceStart() {
	yield takeLatest(vendorTypes.DELETE_SERVICE_START, deleteService);
}

export function* fetchService({ payload }) {
	try {
	  const service = yield handleFetchService(payload);
	  yield put(
		setService(service)
	  );
  
	} catch (err) {
	  console.log(err);
	}
}

export function* onFetchServiceStart() {
	yield takeLatest(vendorTypes.FETCH_SERVICE_START, fetchService);
}

export function* fetchVendors({ payload }) {
	try {	
	  const services = yield handleFetchVendors( payload);
	  yield put(
		setServices(services)
	  );
  
	} catch (err) {
	  console.log(err);
	}
}

export function* onFetchVendorsStart() {
	yield takeLatest(vendorTypes.FETCH_VENDORS_START, fetchVendors);
}

export default function* vendorsSagas() {
	yield all([
	  call(onAddServiceStart),
	  call(onFetchServicesStart),
	  call(onDeleteServiceStart),
	  call(onFetchServiceStart),
	  call(onFetchVendorsStart)
	])
}